
const digest = 'c761cb28606380945d0f3428b19cb88804a166c2b9df626f280d0a5740aeedca';
const classes = {"wrapper":"_wrapper_bx7mo_1","buttonsWrapper":"_buttonsWrapper_bx7mo_9"};
const css = `._wrapper_bx7mo_1 {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px;
  flex-grow: 1;
}

._buttonsWrapper_bx7mo_9 {
  display: flex;
  flex-direction: row;
  gap: 10px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  